import { render, staticRenderFns } from "./BrowserDetect.vue?vue&type=template&id=ddefef1c&scoped=true&"
import script from "./BrowserDetect.vue?vue&type=script&lang=js&"
export * from "./BrowserDetect.vue?vue&type=script&lang=js&"
import style0 from "./BrowserDetect.vue?vue&type=style&index=0&id=ddefef1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddefef1c",
  null
  
)

component.options.__file = "BrowserDetect.vue"
export default component.exports